import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const StatsVisualization = ({ statsData }) => {
  // Transform the statsData into the format needed for the chart
  const chartData = Object.keys(statsData || {})
    .map(key => ({
      name: key,
      clicks: statsData[key]?.clicks || 0,
    }))
    .sort((a, b) => b.clicks - a.clicks); // Sort by click count in descending order

  return (
    <div className="bg-[#191919] rounded-lg shadow-lg p-6 mt-6 border border-[#ffffff18]">
      <h2 className="text-2xl font-bold text-white mb-4">Event Tracking Visualization</h2>
      
      <div className="h-96 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 100,
            }}
          >
            <Bar dataKey="clicks" fill="#8884d8" name="Click Count" />

            <CartesianGrid strokeDasharray="3 3" stroke="#333333" />
            <XAxis 
              dataKey="name" 
              tick={{ fill: "#ffffff" }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis tick={{ fill: "#ffffff" }} />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: "#2d2d2d", 
                border: "1px solid #444", 
                color: "#fff" 
              }}
            />
            <Legend wrapperStyle={{ color: "#ffffff" }} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default StatsVisualization;